// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

export const Wrapper = styled.div<{ bgDesktop?: string; bgMobile?: string }>`
  background-image: ${({ bgMobile }) => `url(${bgMobile})` || 'none'};
  background-position: top center;
  background-repeat: no-repeat;
  background-origin: top;
  background-size: cover;

  ${({ theme }) => theme.breakpoints.up('md')} {
    min-height: 780px;
    background-image: ${({ bgDesktop }) => `url(${bgDesktop})` || 'none'};
  }
`;

export const LeftContent = styled.div`
  max-width: 540px;
`;

export const MicrodegreeCardWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  height: 400px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 300px;
    max-width: 300px;
    height: 480px;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    max-width: 380px;
    width: 380px;
    height: 550px;
  }
  ::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      0deg,
      rgba(14, 26, 72, 0.8) 0.54%,
      rgba(23, 29, 78, 0.8) 39.46%,
      rgba(12, 16, 48, 0) 94.18%
    );
  }
`;

export const SliderWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 800px;
    max-width: 800px;
    right: -40%;
  }
`;
